import React, { useState, useEffect } from "react";
import '../../Work-css/Student_image.css';

function Student_image({
  
 
  gender,
  name,
  date,
  school,
  course,
  ID,
  phonenum,
  email,
  parentnum,
  checked,
  setStudentimage,
  setSPw,
  uniq

  }) {
    const [selectedImage, setSelectedImage] = useState();
    const [sub, setSub] = useState(false)
    const [loading, setLoading] = useState(false)

    const submit = async (event) =>{
     
      event.preventDefault();
      
      setStudentimage(false)
      setSPw(true)

      const fileInput = document.getElementById('file-upload');
      const file = fileInput.files[0];
  
      if (!file) return;
      
      const formData = new FormData();
      formData.append('image', file);
      formData.append('name', name); // Append the name to the form data
      formData.append('gender', gender);
      formData.append('date', date);
      formData.append('school', school);
      formData.append('course', course);
      formData.append('ID', ID);
      formData.append('phonenum', phonenum);
      formData.append('email', email);
      formData.append('parentnum', parentnum);
      formData.append('checked', checked);
      formData.append('unik', uniq);

      try {
        const response = await fetch('https://hosteladventures.site/PHP/Pic_php/Profile_pic.php', {
          method: 'POST',
          body: formData,
        });
  
        const result = await response.json();
        console.log(result);
        // Hide the loading spinner once the response is received
        setLoading(false);
   
        // Handle the response from the server (e.g., display a success message)
      } catch (error) {
        console.error('Error uploading image:', error);
        setLoading(false); // Hide spinner in case of error
      }
    }

    const handleImageChange = (event) => {
        const file = event.target.files[0];
        if (file) {
          const imageUrl = URL.createObjectURL(file);
          setSelectedImage(imageUrl);
         
          setSub(true)
      
        }
      };
  return (
    <div className='whole_IMG'>
       <form onSubmit={submit} className='whole_IMG_BTN'>
          <div className='image_Part'>
                <img src={selectedImage} />  
          </div>

         
          <div className='label_DIV'><label className='img_label' htmlFor="file-upload"> <p className='choose_profile_image'>Choose Profile Image</p></label></div>
          <input className='choose_img' accept="image/jpeg, image/jpg"  id="file-upload"  type='file' onChange={handleImageChange} />
          
          {sub?(<button type='submit' className='submt_btn'>Submit</button>):('')}
          
       </form>
    </div>
  )
}

export default Student_image
